<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-single-dropdown
				formControlName="primaryPowerPlantType"
				[label]="
					'vehicles|record|power-plant-section|field-label|primary-power-plant'
				"
				[selectOptions]="powerPlant" />
			<app-single-dropdown
				formControlName="secondaryPowerPlantType"
				[label]="
					'vehicles|record|power-plant-section|field-label|secondary-power-plant'
				"
				[selectOptions]="powerPlant" />
		</div>
		<div>
			<app-single-dropdown
				formControlName="driveTrainType"
				[label]="
					'vehicles|record|power-plant-section|field-label|drive-train-type'
				"
				[selectOptions]="driveTrainType" />
			<app-single-dropdown
				formControlName="transmissionType"
				[label]="
					'vehicles|record|power-plant-section|field-label|transmission-type'
				"
				[selectOptions]="transmissionType" />
		</div>
	</form>
</app-section-wrapper-container>
